import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useDrafts = () => {
  return useQuery({
    queryKey: ["drafts"],
    queryFn: () => api.drafts.list(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
};
